<template>
    <div class="chart-container">
      <Bar :data="chartData" :options="chartOptions" />
    </div>
  </template>
  
  <script>
  import { Bar } from "vue-chartjs";
  import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
  } from "chart.js";
  
  ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);
  
  export default {
    components: { Bar },
    props: {
      data: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        chartData: this.data,
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
        },
      };
    },
    watch: {
      data(newData) {
        this.chartData = newData;
      },
    },
  };
  </script>
  
  <style scoped>
  .chart-container {
    height: 95%;
    width: 100%;
    position: relative;
  }
  </style>
  